import { useMutation, useQuery } from '@tanstack/react-query';
import {
    getApiPresenceSettings,
    getFieldPresets,
    getSyntheticCancelSettings,
    saveApiPresenceSettings,
    saveSyntheticCancelSettings,
} from './settingsApi';

export const createSettingsHooks = ({ queryClient }) => {
    const useFieldPresets = () =>
        useQuery({
            queryKey: ['fieldPresets'],
            queryFn: getFieldPresets,
            staleTime: 60 * 60 * 1000,
        });

    const useGetSyntheticCancelSettings = () =>
        useQuery({
            queryKey: ['syntheticCancelSettings'],
            queryFn: getSyntheticCancelSettings,
            refetchOnWindowFocus: false,
            retry: false,
        });

    const useSaveSyntheticCancelSettings = () =>
        useMutation({
            mutationFn: saveSyntheticCancelSettings,
            onSuccess: (data) => {
                queryClient.setQueryData(['syntheticCancelSettings'], data);
            },
        });

    const useGetApiPresenceSettings = () =>
        useQuery({
            queryKey: ['apiPresenceSettings'],
            queryFn: getApiPresenceSettings,
            refetchOnWindowFocus: false,
            retry: false,
        });

    const useSaveApiPresenceSettings = () =>
        useMutation({
            mutationFn: saveApiPresenceSettings,
            onSuccess: (data) => queryClient.setQueryData(['apiPresenceSettings'], data),
        });

    return {
        useFieldPresets,
        useGetSyntheticCancelSettings,
        useSaveSyntheticCancelSettings,
        useGetApiPresenceSettings,
        useSaveApiPresenceSettings,
    };
};
